const BLOG_URL = process.env.REACT_APP_BLOG_URL || 'https://adoriai.com/blog';
const CONTACT_URL = process.env.REACT_APP_CONTACT_URL || 'https://adoriai.com/contact';

const Footer = () => {
  const footerLinks = {
    Product: [
      { label: 'Features', href: '#features' },
      { label: 'Pricing', href: '#pricing' },
      { label: 'Blog', href: BLOG_URL },
      { label: 'Docs', href: '#' },
    ],
    Company: [
      { label: 'Reviews', href: '#testimonials' },
      { label: 'Contact', href: CONTACT_URL },
      { label: 'LinkedIn', href: '#' },
      { label: 'YouTube', href: '#' },
    ],
    Legal: [
      { label: 'Privacy Policy', href: '#' },
      { label: 'Terms of Service', href: '#' },
    ],
  };

  return (
    <footer className="py-16 px-6 border-t border-white/5" data-testid="footer">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-12">
          {/* Brand */}
          <div className="col-span-2">
            <a href="#" className="flex items-center gap-1 mb-4">
              <span className="text-2xl font-heading font-bold text-white">Adori</span>
              <span className="text-2xl font-heading font-bold text-brand-primary">AI</span>
            </a>
            <p className="text-gray-400 text-sm leading-relaxed max-w-xs">
              The fastest way for solo creators and bloggers to turn written content into videos that grow an audience.
            </p>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 className="text-white font-semibold mb-4">{category}</h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    <a 
                      href={link.href}
                      className="text-gray-400 hover:text-white transition-colors text-sm"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">© 2025 AdoriAI. All rights reserved.</p>
          <p className="text-gray-500 text-sm">Built for creators who write.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
